import WebDownloadsInfoAccordion from "./WebDownloadsInfoAccordion";

export default WebDownloadsInfoAccordion;
